



























































































































































































































































































import { Vue, photosUrlEnum,getCookie,setCookie } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import StarRating from "vue-star-rating";
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-fineuploader/gallery/gallery.css";
import { cookies,headers } from "../../constants/constants";
import FineUploaderTraditional from "fine-uploader-wrappers";
import Gallery from "vue-fineuploader/gallery/index.vue";
import FileInput from "vue-fineuploader/file-input.vue";
import Thumbnail from "vue-fineuploader/thumbnail/index.vue";
import {
  servicesURL,
  webClientID,
  requestHeaders
} from "../../constants/constants";

export default Vue.component("ReviewStepOne", {
  data() {
    const uploader = new FineUploaderTraditional({
      options: {
        request: {
          endpoint: servicesURL.restaurant.photoUpload,
          inputName: "photo",
          customHeaders: {
          'X-Client-Id': webClientID,
          'Client-Model': 'web',
          'Client-Version': '5',
          'Device-Model': navigator.userAgent,
          'X-Device-Id': getCookie("payload"),
          'Authorization': `Bearer ${getCookie('Authorization')}`
          }
        },
        retry: {
						enableAuto: true
					}
      }
    });
    return {
      staticContent,
      uploader,
      state: {
        submittedFiles: []
      },

      branchesData: [],
      selectedBranch: {},
      rating: 0,
      reviewText: "",
      images: [],
      itemsData: null,
      loadingImg: false,
      tagModel: [],
      APIData: {
        restaurantUUID: null,
        branchUUID: null,
        rating: 0,
        photos: null
      },
      reviewLoader: false,
      reviewAdded: false
    };
  },
  components: {
    StarRating,
    Multiselect,
    Gallery,
    FileInput,
    Thumbnail
  },
  props: {
    componentname: null,
    users: null,
    adminuuid: null,
    shortCode: {
      required: true,
      type: String
    }
  },
  mounted() {
    this.setUpImgUploadEvents();
    this.setupBranches();
    this.setupItems();
  },
  computed: {
      bindConditionalClasses(){
     return this.$root.bindConditionalClasses;
    },
    branches() {
      return this.$root.restaurantBranches;
    },
    restaurantUUID() {
      return this.$root.restaurantUUID;
    },
    restaurantName() {
      return this.$root.restaurantPage.restHeaderObj.name;
    },
    currentBranchUuid() {
      return this.$root.restaurantPage.restHeaderObj.branchUUID;
    },
    items() {
      return this.$root.items;
    }
  },
  methods: {
    modalToggler(modalId,method){
      this.$root.modalToggler(modalId,method)
    },
    setUpImgUploadEvents() {
        this.uploader.on('submit', () => {
				this.uploader.methods.setCustomHeaders({
          'Authorization': `Bearer ${getCookie('Authorization')}`,
					'X-Client-Id': webClientID,
          'X-Device-Id': getCookie("payload"),
				})
			});
			this.uploader.on('autoRetry', () => {
			 axios.put(servicesURL.user.login, getCookie('webRefreshToken'), {
          headers: { "Content-Type": "application/json"
       } })
        .then(res => {
         	setCookie('Authorization', res.data.accessToken, '/');
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.accessToken;
					headers['Authorization'] = 'Bearer ' + res.data.accessToken;
					setCookie('webRefreshToken', res.data.refreshToken, '/');
					this.uploader.methods.setCustomHeaders({
          'Authorization': `Bearer ${getCookie('Authorization')}`,
					'X-Client-Id': webClientID,
          'X-Device-Id': getCookie("payload"),
					})
				})

			})
		
      this.uploader.on("allComplete",()=>{
                      this.loadingImg = false;

      })
       this.uploader.on("statusChange",()=>{
                      this.loadingImg = true;

      })
      this.uploader.on("complete", (id, oldStatus, newStatus) => {
        this.tagModel.push(null);

        const submittedFiles = this.state.submittedFiles;
        submittedFiles.push(id);
        this.$set(this.state, "submittedFiles", submittedFiles);
        if (newStatus.success) {
          let obj = {
            id: "",
            photoUUID: "",
            restaurantUUID: "",
            branchUUID: ""
          };
          obj.id = id;
          obj.photoUUID = newStatus.uuid;
          obj.restaurantUUID = this.restaurantUUID;
          obj.branchUUID = this.selectedBranch["uuid"];
          this.images.push(obj);
        } else {
          console.log("error", newStatus);
        }
      });
    },
    async setupBranches() {
      let mappedBranches = [];
      try {
        const res = await axios({
          method: "GET",
          url: servicesURL.restaurant.getCompactBranches(this.shortCode),
          headers,
        });
        const branchesList = res.data.compactBranches;
        mappedBranches = branchesList.map((branch) => {
          const obj = {
            branch: branch.name + "/" + branch.address,
            uuid: branch.uuid
          }
          if (branch.uuid == this.currentBranchUuid) {
            this.selectedBranch = obj;
          }
          return obj;
        })

      } catch (err) {
        console.log(err);
      }

      this.branchesData = mappedBranches;
    },
    setupItems() {
      let arr = [];
      for (var key in this.items) {
        let obj = {};
        obj["name"] = this.items[key].name;
        obj["uuid"] = this.items[key].itemUUID;
        obj["categoryName"] = this.items[key].categoryName;
        arr.push(obj);
      }
      this.itemsData = arr;
    },
    checkValidation() {
      return this.rating == 0 || this.reviewText.length < 40;
    },
    cancelUploadPhotos() {
      this.state.submittedFiles = [];
      this.images = [];
      this.tagModel = [];
    },
   
    deletePhoto(id, targetIndex) {
      this.tagModel.splice(targetIndex, 1);

      this.state.submittedFiles.indexOf(id) > -1 &&
        this.state.submittedFiles.splice(
          this.state.submittedFiles.indexOf(id),
          1
        );
      this.images.map((image, index) => {
        if (image.id == id) {
          this.images.splice(index, 1);
        }
      });
    },
    addReview() {
      this.APIData.restaurantUUID = this.restaurantUUID;
      this.APIData.branchUUID = this.selectedBranch["uuid"];
      this.APIData.text = this.reviewText;
      this.APIData.rating = this.rating;
      this.APIData.photos = this.images;

      this.APIData.photos.map((photo, i) => {
        this.APIData.photos[i].itemUUID = this.tagModel[i]?this.tagModel[i].uuid:null;
      });
      this.reviewLoader = true;
       axios({
        method: "POST",
        url: servicesURL.restaurant.addReview,
        headers,
        data: JSON.stringify(this.APIData)
      })
      .then(res =>{
          this.reviewLoader = false;
          this.modalToggler("confirm-review-modal", "show");
          this.reviewAdded=true
          this.rating=0;
          this.reviewText=''

        }).
        catch( res => {
          console.log("error: ", res);
          this.modalToggler("confirm-review-modal", "show");
          this.reviewAdded=false
        });
    },
    confirmModalHandeler() {
      if(this.reviewAdded){
         
      window.location.reload();
      }
      else{
          this.modalToggler("confirm-review-modal", "hide");
          this.reviewAdded=false
         


      }
    }
  }
});
